import { Container, Typography } from '@mui/material'
import { PIGGY_BANKS_MULTIPLIER } from '@playback-rewards/shared-libraries'
//components
import RedemptionHistoryItem from './Item'
//styles
import './index.css'
//types
import { RedemptionHistoryProps } from 'types'

const RedemptionHistory = ({ redemptions }: RedemptionHistoryProps) => {
  return (
    <>
      <Container maxWidth="sm" sx={styles.container}>
        <div className="accountBalanceRedemptionInner">
          <Typography variant="h3" sx={styles.text}>
            Redemption History
          </Typography>
          <div className="accountBalanceRedemptionContent">
            {!redemptions?.length && (
              <Typography variant="body2" sx={styles.text}>
                All of your historical gift card redemptions show up here. You don’t have any yet,
                so get out there and start earning some rewards!
              </Typography>
            )}
            {redemptions?.map((giftCardOrder) => (
              <RedemptionHistoryItem
                key={giftCardOrder.id}
                title={`${giftCardOrder.giftCardName} Gift Card`}
                claimedAt={giftCardOrder.claimedAt}
                value={`$${giftCardOrder.totalPrice}`}
                spentCoins={giftCardOrder.spentCoins}
                spentPiggyBanks={
                  giftCardOrder.spentPiggyBanks ||
                  PIGGY_BANKS_MULTIPLIER(Number(giftCardOrder.totalPrice))
                }
                imageUrl={giftCardOrder.giftCardImage}
              />
            ))}
          </div>
        </div>
      </Container>
    </>
  )
}

const styles = {
  container: {
    padding: 0,
  },
  text: {
    padding: '0 16px',
  },
}

export default RedemptionHistory
